<cc-icon
    id="refresh-dashboard"
    [icon]="'refresh'"
    [size]="'medium'"
    title="Refresh"
    (iconClicked)="refresh.emit()"
>
</cc-icon>

@if (showRestore) {
    <cc-icon
        #restoreIcon
        [icon]="'chevron-down2'"
        [size]="'medium'"
        (iconClicked)="showRestoreModal = !showRestoreModal"
    >
    </cc-icon>
}

@if (showRestoreModal) {
    <div [ccModal]="modalOptions" (dismissed)="showRestoreModal = false" class="restore-wrapper">
        <span (click)="onRestoreClick()">Restore Default View</span>
    </div>
}
